export default __webpack_public_path__ + "static/char-s-20-ko-3270bbb9c7a9e8253ba9a29c6760536e.webp";